import { Component, OnInit } from '@angular/core';
import { ApiService } from '../service/api.service';
import { Router } from '@angular/router';
declare var swal: any;
@Component({
  selector: 'app-approve-college',
  templateUrl: './approve-college.component.html',
  styleUrls: ['./approve-college.component.scss']
})
export class ApproveCollegeComponent implements OnInit {
  approveCoachListdata: any;
  constructor(private router: Router, private ApiService: ApiService) { }

  ngOnInit() {
    this.getCoachUserListApi();
  }

  async getCoachUserListApi() {
    var getapi = "/approve_faculty_list ";
    (await this.ApiService.getApi(getapi)).subscribe((res) => {
  
      this.approveCoachListdata = res.result;
    });

  }
  async approveCoachApi(items:any) {
   var coachUserId = items.user_id;
   var postapi = "/approve_faculty";
    var approveCoachdata = {
      "user_id": coachUserId,
      "status": 1
    };
    (await this.ApiService.postApi(postapi, approveCoachdata)).subscribe(
      res => {
        if (res) {
          if (res.status === 200) {
            swal({
              icon: 'Success!',
              text: "Approved  Succcessfully",
              type: "success"
            }, function () {
              alert('yo');
            });
          }
        }
        this.getCoachUserListApi();
      });
  }

  async cancelCoachApi(coachItem:any) {
    var coach_UserId = coachItem.user_id;
    var postapi = "/approve_faculty";
    var approveCoachdata = {
      "user_id": coach_UserId,
      "status": "0"
    };
    (await this.ApiService.postApi(postapi, approveCoachdata)).subscribe(
      res => {
        if (res) {
          if (res.status === 200) {
            swal({
              icon: 'Success!',
              text: "Cancel Coach User Succcessfully",
              type: "success"
            }, function () {
              alert('yo');
            });
          }
        }
        this.getCoachUserListApi();
      });
  }


}
